import { type SalesCountComparisonChartFilter } from '@/app/[locale]/(authorized)/(dashboard)/components/Dashboard/components/Charts/components/SalesCountComparisonChart/components/SalesCountComparisonChartFilter';
import { type SalesVolumeComparisonChartFilter } from '@/app/[locale]/(authorized)/(dashboard)/components/Dashboard/components/Charts/components/SalesVolumeComparisonChart/components/SalesVolumeComparisonChartFilter';

import type { SalesPerCurrencyChartQuery } from '../../../../../../../../../../generated/graphql';

type ComparisonChartFilter = SalesVolumeComparisonChartFilter | SalesCountComparisonChartFilter;

type ComparisonGateNames = readonly [string | undefined, string | undefined];

export function getComparisonGateNames(
  data?: SalesPerCurrencyChartQuery['dashboardWidgetsSalesPerCurrencyChartV2'],
  filter?: ComparisonChartFilter
): ComparisonGateNames {
  if (data) {
    return [data.gate_group_1.gate_group_name, data.gate_group_2.gate_group_name];
  }

  if (!filter) {
    return [undefined, undefined];
  }

  return [filter.gateGroups.at(0)?.name, filter.gateGroup?.name ?? filter.gateGroups.at(1)?.name];
}
